import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { callIfChanged } from 'utilities/forms';

import { generateDistributionData } from 'store/scenes/distributions/actions';
import { getDistributionsFormValues } from 'store/form/distributions/selectors';

import BinomialDistributionFieldsComponent from './Component';

class BinomialDistributionFieldsContainer extends React.PureComponent {
  makeHandleChangeFn = property => callIfChanged((_, newValue) => {
    this.props.generateDistributionData({ [property]: newValue });
  });

  handleNumberOfTrials = this.makeHandleChangeFn('numberOfTrials');

  handleProbabilityOfSuccess = this.makeHandleChangeFn('probabilityOfSuccess');

  render () {
    return (
      <BinomialDistributionFieldsComponent
        onNumberOfTrials={this.handleNumberOfTrials}
        onProbabilityOfSuccess={this.handleProbabilityOfSuccess}
      />
    );
  }
}

const mapDispatchToProps = {
  generateDistributionData: values => (dispatch, getState) => {
    const distributionFormValues = getDistributionsFormValues(getState());
    dispatch(generateDistributionData({ ...distributionFormValues, ...values }));
  }
};

BinomialDistributionFieldsContainer.propTypes = {
  generateDistributionData: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(
  BinomialDistributionFieldsContainer
);
